/**
 * Construct Vuex 'permissions' module
 *
 * @param {*} services Services object for API access
 * @return {*}
 */
export default function(services) {
  return {
    namespaced: true,
    state: {
      permissions: [],
      servicePermissions: [],
      requiresUpdate: true
    },
    mutations: {
      permissions(state, permissions) {
        state.permissions = permissions;
      },
      servicePermissions(state, servicePermission) {
        state.servicePermissions = servicePermission;
      },
      requiresUpdate(state, requiresUpdate) {
        state.requiresUpdate = requiresUpdate;
      }
    },
    actions: {
      initialize(context, forceUpdate) {
        if (context.state.requiresUpdate || forceUpdate) {
          context.commit('requiresUpdate', false);

          return services.authenticator.get('/permissions').then((response) => {
            context.commit('permissions', response.data.data.permissions);
            context.commit('servicePermissions', response.data.data.servicePermissions);
          });
        } else {
          return Promise.resolve();
        }
      }
    }
  };
}
